<template>
  <div id="sector-primers" class="section-container">
    <div class="d-flex justify-space-between">
      <header-title-two :loading="loading" title="Sector Primers" />
      <template v-if="sectorPrimers.length > 0">
        <previous-next-navigation
          :navIndex="slide"
          :navLast="sectorPrimers.length - numberOfSlides"
          v-on:on-prev="onNav('prev')"
          v-on:on-next="onNav('next')"
          class-name="align-center tech-nav justify-end"
        />
      </template>
    </div>
    <div>
      <skeleton-card-list
        direction="horizontal"
        type="media"
        :isCard="true"
        :withoutMedia="true"
        :number="numberOfSlides"
        :loading="loading"
        class="overflow-hidden flex-nowrap py-4"
      >
        <slick-carousel
          v-if="sectorPrimers.length > 0"
          ref="slickCarousel"
          class="carousel-card"
          :settings="slickSettings"
          :itemsToShow="numberOfSlides"
          @afterChange="afterChange"
        >
          <sector-primer-card
            v-for="item in sectorPrimers"
            v-bind:key="item.id"
            :id="item.id"
            :title="item.title"
            :file="item.url"
            :icon="item.image"
            class="card"
          />
        </slick-carousel>
      </skeleton-card-list>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { SectorPrimersApi } from '@gslc/models';
import { openApiConfig } from '../../api/config';
import HeaderTitleTwo from '../../components/typography/header-title-2.vue';
import SlickCarousel from '../../components/carousel/SlickCarousel.vue';
import PreviousNextNavigation from '../../components/PreviousNextNavigation.vue';
import SectorPrimerCard from '../../components/cards/SectorPrimerCard.vue';
import { defaultSlickSettings, getNumberOfSlides } from '../../utils/carousel';

const sectorPrimersApi = new SectorPrimersApi(openApiConfig());
const responsivePoints = [
  500,
  600,
  768,
  850,
  960,
  1100,
  1264,
  1440,
];

export default {
  name: 'HomeSectorPrimers',
  components: {
    HeaderTitleTwo,
    SlickCarousel,
    SectorPrimerCard,
    PreviousNextNavigation,
  },
  data: () => ({
    loading: false,
    slide: 0,
    windowWidth: window.innerWidth,
    slickSettings: defaultSlickSettings([6, 6, 5, 4, 3.5, 3, 2.5, 2, 1.5], responsivePoints),
  }),
  computed: {
    ...mapGetters(['sectorPrimers', 'windowWidth']),
    numberOfSlides () {
      return getNumberOfSlides(this.windowWidth, [1.5, 2, 2.5, 3, 3.5, 4, 5, 6, 6], responsivePoints);
    }
  },
  methods: {
    ...mapActions(['setSectorPrimers']),
    async fetchSectorPrimers () {
      this.loading = true;
      const accessToken = await this.$auth.getTokenSilently();
      const sectorPrimers = await sectorPrimersApi.getSectorPrimers({
        headers: { Authorization: `Bearer ${accessToken}` },
      });
      this.setSectorPrimers(sectorPrimers.data.data || []);
      this.loading = false;
    },
    afterChange(slideNumber) {
      this.slide = slideNumber;
    },
    onNav(type) {
      switch (type) {
        case 'prev':
          this.$refs.slickCarousel.$children[0].prev();
          break;
        case 'next':
        default:
          this.$refs.slickCarousel.$children[0].next();
      }
    },
    onResize () {
      this.windowWidth = window.innerWidth;
    }
  },
  async mounted () {
    await this.fetchSectorPrimers();
    this.$nextTick(() => {
      window.addEventListener('resize', this.onResize);
    });
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.onResize);
  },

};
</script>

<style lang="css" scoped>
.carousel-card >>> div.slick-slide, .carousel-card >>> div.scroll > div {
  height: unset !important;
}
.carousel-card >>> div.slick-slide > div {
  height: 100%;
}
@media (min-width: 960px) {
  .carousel-card >>> div.slick-slide {
    width: calc(25vw - 17px) !important;
    flex-shrink: 0;
  }
  .carousel-card >>> div.slick-track, .carousel-card >>> div.scroll {
    display: flex;
    align-items: stretch;
    width: min-content !important;
  }
}
@media (min-width: 1100px) {
  .carousel-card >>> div.slick-slide {
    width: calc(20vw - 13px) !important;
  }
}
@media (min-width: 1263px) {
  .carousel-card >>> div.slick-slide {
    width: calc(16vw - 3px) !important;
  }
}
@media (min-width: 1440px) {
  .carousel-card >>> div.slick-slide {
    width: 230px !important;
  }
}
</style>
